import React, { useState } from "react";
import "./Team.css";
import SocialButtons from "./SocialButtons";

const TeamSection = () => {
  const teamMembers = [
    {
      name: "Anubhi Khandelwal",
      role: "Co-Founder & CEO",
      imageUrl: require("../../assets/team//anubhi_mam_image.png"),
      socialLinks: [
        {
          icon: "linkedin",
          url: "https://www.linkedin.com/in/anubhikhandelwal/",
        },
        {
          icon: "Instagram",
          url: "https://www.instagram.com/thegirlfounder/?igsh=cjNta3pjaWMyaXo4#",
        },
      ],
    },
    {
      name: "Amrit Singh",
      role: "Co-Founder & CTO",
      imageUrl: require("../../assets/team/amrit_sir_images.png"),
      socialLinks: [
        {
          icon: "linkedin",
          url: "https://www.linkedin.com/in/attentionverse/",
        },
        {
          icon: "Instagram",
          url: "https://www.instagram.com/liveamrit/?igsh=M2l5OGd0bHQ3ZjVp#",
        },
      ],
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const currentMember = teamMembers[currentIndex];
  const nextMember = teamMembers[(currentIndex + 1) % teamMembers.length];

  return (
    <>
      <section id="home-team" className="home-team">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row">
            <div className="col-lg-6">
              <div className="content" data-aos="fade-up" data-aos-delay="200">
                <div className="text-section">
                  <h2 className="main-team-heading fs-xl-heading">
                    Meet the Founders
                  </h2>
                  <p className="lead">
                    Anubhi Khandelwal, ex-Siemens UK, brings over 9 years of
                    hands-on experience in industrial automation. Her deep,
                    practical insight into the intricacies of manufacturing has
                    been honed through years of direct work on the shop floor,
                    where she's designed solutions tailored to the real-world
                    challenges faced by manufacturing industries in India and
                    Europe.
                  </p>
                  <p className="lead">
                    Amrit Singh, an IITD graduate and serial entrepreneur,
                    brings the AI perspective to the team. From founding a
                    fashion rental startup acquired by Craftsvilla to running a
                    million-dollar technology studio, he's consistently pushed
                    innovation. He also led an AI lab focused on next-gen
                    automation and Gen AI-driven prototypes.
                  </p>
                  <p className="lead">
                    Together, they combine deep industry knowledge with
                    cutting-edge technology to redefine welding and
                    manufacturing.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 d-flex justify-content-center justify-content-lg-end align-items-center p-0 m-0">
              <div
                className="image-section"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <div className="team-members-grid">
                  <div className="team-member">
                    <div className="image-container">
                      {currentMember.imageUrl && (
                        <>
                          <img
                            src={currentMember.imageUrl}
                            alt={currentMember.name}
                            className="member-image border"
                          />
                          <SocialButtons links={currentMember.socialLinks} />
                        </>
                      )}
                    </div>
                    <div className="member-info">
                      <h3>{currentMember.name}</h3>
                      <p>{currentMember.role}</p>
                    </div>
                  </div>

                  <div className="team-member">
                    <div className="image-container">
                      {nextMember.imageUrl && (
                        <>
                          <img
                            src={nextMember.imageUrl}
                            alt={nextMember.name}
                            className="member-image border"
                          />
                          <SocialButtons links={nextMember.socialLinks} />
                        </>
                      )}
                    </div>
                    <div className="member-info">
                      <h3>{nextMember.name}</h3>
                      <p>{nextMember.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TeamSection;
